module.exports = "<form class=\"\">\n  <div class=\"input-group\">\n    <span class=\"input-group-addon danger\"><span class=\"glyphicon glyphicon-search\"></span></span>\n    <input type=\"text\" class='form-control' placeholder=\"关键词\" (input)=\"typing.next($event.target.value)\">\n  </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/forms/search-box/search-box.com.html
// module id = ./src/app/modules/shared/forms/search-box/search-box.com.html
// module chunks = main